import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCardsBrandsService } from '../../Services';

const createBaseAsyncMethod = (actionName: string, serviceMethod: any) => {
  return createAsyncThunk(
    actionName,
    async (_, { rejectWithValue }: any) => {
      const response = await serviceMethod();
      /* manipular response y checkeo de errores */
      
        if(response?.data && response?.status === 200){
          return response.data;
        }
        else {
          return rejectWithValue({ errorMessage: 'Error al obtener las marcas de tarjetas'})
        }
      
    }
  );
}

export const getCardsBrandsAsync = createBaseAsyncMethod('creditCards/fetchGetBrands',  getCardsBrandsService()?.getCardsBrands);


